import { getZrmListingInfo, getZrmUserInfo } from '@zg-rentals/clickstream';
import { trackEvent } from '../index';
import type { ZrmClickstreamListing, ZrmClickstreamUser } from '@zg-rentals/clickstream';

const EVENT_IDS = {
  EMPTY_LEASES_GET_STARTED: '2848',
  CREATE_A_LEASE: '2849',
  VIEW_ALL_LEASES: '3535',
  VIEW_GENERATED_LEASE: '8119',
} as const;

export const EMPTY_LEASES_GET_STARTED_EVENT_ID = EVENT_IDS.EMPTY_LEASES_GET_STARTED;
export const CREATE_A_LEASE_EVENT_ID = EVENT_IDS.CREATE_A_LEASE;
export const VIEW_ALL_LEASES_EVENT_ID = EVENT_IDS.VIEW_ALL_LEASES;
export const VIEW_GENERATED_LEASE_EVENT_ID = EVENT_IDS.VIEW_GENERATED_LEASE;

// https://dataportal.zillowgroup.net/event-registry/3535
export const emitViewAllLeasesEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.VIEW_ALL_LEASES,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'sense_of_home | manage_tenants',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'view_all_leases',
    },
    semantic: {
      semantic_event_nm: 'view_all_leases',
      topic_tag_txt: ['zrm_leases'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2849
export const emitCreateALeaseEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.CREATE_A_LEASE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'sense_of_home | manage_tenants',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'create_a_lease',
    },
    semantic: {
      semantic_event_nm: 'start_lease',
      topic_tag_txt: ['zrm_leases'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/2848
export const emitEmptyLeasesGetStartedEvent = ({ user }: { user: ZrmClickstreamUser }) =>
  trackEvent.user({
    envelope: {
      event_template_id: '168',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.EMPTY_LEASES_GET_STARTED,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'sense_of_home | manage_tenants',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'get_started_lease',
    },
    semantic: {
      semantic_event_nm: 'start_lease',
      topic_tag_txt: ['zrm_leases'],
    },
    ...getZrmUserInfo(user),
  });

// https://dataportal.zillowgroup.net/event-registry/8119
export const emitViewGeneratedLeaseEvent = ({
  currentProperty,
  user,
}: {
  currentProperty: ZrmClickstreamListing;
  user: ZrmClickstreamUser;
}) =>
  trackEvent.listingUser({
    envelope: {
      event_template_id: '283',
      event_template_version_id: '1',
      event_type_id: EVENT_IDS.VIEW_GENERATED_LEASE,
      event_type_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'zrm_property_overview',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'view_lease',
    },
    semantic: {
      semantic_event_nm: 'click_view_lease',
      topic_tag_txt: [],
    },
    ...getZrmListingInfo(currentProperty),
    ...getZrmUserInfo(user),
  });
